import React, { Component } from 'react'
import { getTransancionDetails } from '../../action/SubscriptionManagement';
import queryString from 'query-string';
import PaymentFailse from '../../old_Components/Package/PaymentFailse';
import PaymentProcessing from '../../old_Components/Package/PaymentProcessing';
import SuccessPayment from '../../old_Components/Package/SuccessPayment';
import Shimmer from '../../old_Components/Common/Shimmer';
export default class page extends Component {
    constructor(props) {
        super(props);
        this.state = {
            PACKAGE_TITLE: undefined,
            PAYMENT_STATUS: undefined,
            ORDER__ID:undefined
        }
    }

    componentDidMount() {

        const qParam = queryString.parse(this.props?.location?.search)
        getTransancionDetails(qParam?.txn).then(res => {
            if (res.status) {
                this.setState({ PACKAGE_TITLE: res.result.PACKAGE_TITLE, PAYMENT_STATUS: res.result.PAYMENT_STATUS ,ORDER__ID:res.result.PKG_SUBSC_ID
                })
            }
        })
    }

    render() {
        const { PAYMENT_STATUS, PACKAGE_TITLE,ORDER__ID } = this.state
        return (
            <React.Fragment>
                {!PAYMENT_STATUS && <React.Fragment><Shimmer/>
                <Shimmer/><Shimmer/><Shimmer/> </React.Fragment>}
                {PACKAGE_TITLE && PAYMENT_STATUS && PAYMENT_STATUS === 'S' && <SuccessPayment
                    packageName={PACKAGE_TITLE}
                    Order_Id={ORDER__ID}
                    txn={queryString.parse(this.props?.location?.search).txn} />}
                {PAYMENT_STATUS && PAYMENT_STATUS === 'P' && <PaymentProcessing />}
                {PAYMENT_STATUS && PAYMENT_STATUS === 'F' && <PaymentFailse />}
            </React.Fragment>
        )
    }
}
